export type ColorPalette = {
    colorPaletteId: string;
    displayName: string;
    colors: string[];
    isDefault: boolean;
    isGradient: boolean;
};
